import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'shortName',
})

/**
* get the short name
*/
export class ShortNamePipe implements PipeTransform {
  transform(fullName: string): string {
    const allNames = fullName?.replace(/<[^>]*>?/gm, '').trim().split(' ');
      return allNames?.reduce((acc, curr, index) => {
        if (index === 0 || index === allNames.length - 1) {
            acc = `${acc}${curr.charAt(0).toUpperCase()}`;
        }
        return acc;
    }, '');
  }
}
